import { render, staticRenderFns } from "./RegistrationIcon.vue?vue&type=template&id=86de46c2"
import script from "./RegistrationIcon.vue?vue&type=script&lang=js"
export * from "./RegistrationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports